import { render, staticRenderFns } from "./GroupTopicCreate.vue?vue&type=template&id=479e9756&scoped=true"
import script from "./GroupTopicCreate.vue?vue&type=script&lang=js"
export * from "./GroupTopicCreate.vue?vue&type=script&lang=js"
import style0 from "./GroupTopicCreate.vue?vue&type=style&index=0&id=479e9756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e9756",
  null
  
)

export default component.exports